import { apiSlice } from './apiSlice';

export const planetStrengthsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPlanetStrengths: builder.query<any, string | null>({
      query: (userId) => ({
        url: '/astrology/strengths',
        method: 'GET',
        params: { userId },
      }),
    }),
  }),
});

export const { useGetPlanetStrengthsQuery } = planetStrengthsApi;
